export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative text-white py-16" style={{ backgroundColor: '#6b3d52' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <a
              href="#"
              className="text-3xl font-bold text-white transition-colors duration-300"
              onMouseEnter={(e) => e.currentTarget.style.color = '#fecdd3'}
              onMouseLeave={(e) => e.currentTarget.style.color = 'white'}
            >
              Charit Patel
            </a>
            <p className="text-rose-50 mt-2">UI/UX Designer</p>
            <p className="text-rose-100/80 text-sm leading-relaxed mb-6">
              Creating delightful digital experiences through thoughtful design and user-centered thinking.
            </p>
            {/* Social Links */}
            <div className="flex gap-3">
              <a
                href="https://www.linkedin.com/in/charit-patel-2533581ba/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg hover:bg-white/20 transition-all duration-300 group cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg text-white"></i>
              </a>
              <a
                href="https://www.behance.net/charitpatel06"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg hover:bg-white/20 transition-all duration-300 group cursor-pointer"
              >
                <i className="ri-behance-fill text-lg text-white"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold text-white mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a href="#about" className="text-rose-100/80 transition-colors duration-300 text-sm"
                   onMouseEnter={(e) => e.currentTarget.style.color = '#fecdd3'}
                   onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255, 241, 242, 0.8)'}>
                  About Me
                </a>
              </li>
              <li>
                <a href="#journey" className="text-rose-100/80 transition-colors duration-300 text-sm"
                   onMouseEnter={(e) => e.currentTarget.style.color = '#fecdd3'}
                   onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255, 241, 242, 0.8)'}>
                  My Journey
                </a>
              </li>
              <li>
                <a href="#projects" className="text-rose-100/80 transition-colors duration-300 text-sm"
                   onMouseEnter={(e) => e.currentTarget.style.color = '#fecdd3'}
                   onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255, 241, 242, 0.8)'}>
                  Projects
                </a>
              </li>
              <li>
                <a href="#contact" className="text-rose-100/80 transition-colors duration-300 text-sm"
                   onMouseEnter={(e) => e.currentTarget.style.color = '#fecdd3'}
                   onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255, 241, 242, 0.8)'}>
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold text-white mb-4">Services</h4>
            <ul className="space-y-3">
              <li className="text-rose-100/80 text-sm">UI/UX Design</li>
              <li className="text-rose-100/80 text-sm">Product Design</li>
              <li className="text-rose-100/80 text-sm">User Research</li>
              <li className="text-rose-100/80 text-sm">Design Systems</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold text-white mb-4">Get in Touch</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-rose-300 mt-1"></i>
                <span className="text-rose-100/80 text-sm">Toronto, Canada</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-rose-300 mt-1"></i>
                <a href="mailto:charitrpatel@gmail.com" className="text-rose-100/80 transition-colors duration-300 text-sm"
                   onMouseEnter={(e) => e.currentTarget.style.color = '#fecdd3'}
                   onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255, 241, 242, 0.8)'}>
                  charitrpatel@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-rose-300 mt-1"></i>
                <a href="tel:+19055989502" className="text-rose-100/80 transition-colors duration-300 text-sm"
                   onMouseEnter={(e) => e.currentTarget.style.color = '#fecdd3'}
                   onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255, 241, 242, 0.8)'}>
                  +1 905 5989502
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-rose-100/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-rose-100/80 text-sm">
              © {currentYear} Charit Patel. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-rose-100/80 transition-colors duration-300 text-sm font-medium"
              onMouseEnter={(e) => e.currentTarget.style.color = '#fecdd3'}
              onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255, 241, 242, 0.8)'}
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
